"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styles = require("@material-ui/core/styles");
var _react = _interopRequireDefault(require("react"));
var _theme = _interopRequireDefault(require("./theme"));
var _themeEbserh = _interopRequireDefault(require("./themeEbserh"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var CustomThemeProvider = function CustomThemeProvider(_ref) {
  var children = _ref.children,
    config = _ref.config;
  var selectedTheme = _react["default"].useMemo(function () {
    return config.config_id === "ebserh" || config.basename === "ebserh" ? _themeEbserh["default"] : _theme["default"];
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_styles.ThemeProvider, {
    theme: (0, _styles.createTheme)(selectedTheme)
  }, children);
};
var _default = CustomThemeProvider;
exports["default"] = _default;